import { useState } from "react";
import { Box, TextField, Button, Typography } from "@mui/material";


export default function PostRequirement() {
  const [form, setForm] = useState({
    property_type: "",
    min_budget: "",
    max_budget: "",
    city: "",
    bhk: ""
  });

  const submit = async () => {
    
  };

  return (
    <Box sx={{ maxWidth: 600, mx: "auto", mt: 5 }}>
      <Typography variant="h5" mb={2}>
        Post Your Property Requirement
      </Typography>

      <TextField fullWidth label="Property Type" margin="normal"
        onChange={(e) => setForm({ ...form, property_type: e.target.value })} />

      <TextField fullWidth label="Min Budget" type="number" margin="normal"
        onChange={(e) => setForm({ ...form, min_budget: e.target.value })} />

      <TextField fullWidth label="Max Budget" type="number" margin="normal"
        onChange={(e) => setForm({ ...form, max_budget: e.target.value })} />

      <TextField fullWidth label="City" margin="normal"
        onChange={(e) => setForm({ ...form, city: e.target.value })} />

      <TextField fullWidth label="BHK" margin="normal"
        onChange={(e) => setForm({ ...form, bhk: e.target.value })} />

      <Button variant="contained" fullWidth sx={{ mt: 2 }} onClick={submit}>
        Submit Requirement
      </Button>
    </Box>
  );
}